import { NavLink } from "navigation/styled";
import * as React from "react";

interface LinkWithMessageBubbleProps {
    href: string;
}

const LinkWithMessageBubble: React.FC<LinkWithMessageBubbleProps> = ({ href }) => {
    return (
        <NavLink href={href} rel="noreferrer" style={{ alignItems: "center" }}>
            <i className="ci-message_round" style={{ marginRight: '8px', fontSize: "24px" }} />
            {FRENDS.Localizations.Help}
        </NavLink>
    )
};

export default LinkWithMessageBubble;
